import * as React from "react"
import type { IconProps } from "../types"

const CheckMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 20, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 20 20"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="m5.833 10.417 3.334 3.333 5-7.5"
        />
      </svg>
    )
  }
)
CheckMini.displayName = "CheckMini"

export default CheckMini
